import { chainManager } from '../ChainManager';

export async function sendGasToManyViaChainManager(receivers: string[], lixiBagAddress: string, value = 0): Promise<any> {
  const adapter = chainManager.getCurrentAdapter();
  if (!adapter?.sendRewardToMany) throw new Error('Adapter chưa hỗ trợ sendRewardToMany');
  return adapter.sendRewardToMany(receivers, value);
}
